import PaymentsInvoices from './PaymentsInvoices';

export default PaymentsInvoices;
